/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{env as e}from"./env.js";function n(n){return e.isServer?null:n instanceof Node?n.ownerDocument:null!=n&&n.hasOwnProperty("current")&&n.current instanceof Node?n.current.ownerDocument:document}export{n as getOwnerDocument};
//# sourceMappingURL=owner.js.map
